<h2 style="cursor:pointer;" class="flex-aligned-div" (click)="openLogsHistory()">
  @if (defaults.isadminuser) {
    <button mat-icon-button (click)="openCreatePopup(); $event.stopPropagation()" matTooltip="Add new Function Config">
      <mat-icon>add</mat-icon>
    </button>
  }
  <span class="logs-history-label">
    Logs History
    <mat-icon data-html="true" style="color:white">info</mat-icon>
  </span>
</h2>
<div class="example-container">
  <table mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    matSort
    class="mat-elevation-z8 mat-table-custom" id="functionsconfig">
    @for (item of columnsToDisplay; track item) {
      <ng-container matColumnDef="{{item}}">
        <th mat-header-cell *matHeaderCellDef>
          {{item === 'Enabled' || item === 'arrow' || item === 'index'? '' : item}}
          @if (item !== 'Enabled' && item !== 'arrow' && item !== 'index') {
            <mat-icon class="info-tooltip" matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="{{tooltips[item]}}">info</mat-icon>
          }
        </th>
        @if (item==='Enabled') {
          <ng-container *matCellDef="let element">
            @if (defaults.isControllerOwner) {
              @if (getInput(element,'Enabled') === true) {
                <td mat-cell>
                  <button mat-icon-button matTooltip="Add new Function Param" (click)="onRowEditInit(undefined, element)">
                    <mat-icon>library_add</mat-icon>
                  </button>
                  <button mat-icon-button (click)="changeElement(element, false)" matTooltip="Disallow Function">
                    <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                  </button>
                </td>
              }
              @if (!getInput(element,'Enabled')) {
                <td mat-cell>
                  <button mat-icon-button (click)="changeElement(element, true)" matTooltip="Allow Function">
                    <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                  </button>
                </td>
              }
            }
            @if (!defaults.isControllerOwner) {
              <td mat-cell>
                @if (getInput(element,'Enabled') === true) {
                  <p class="mat-icon-green">Enabled</p>
                }
                @if (getInput(element,'Enabled') === false) {
                  <p class="mat-icon-grey">Disabled</p>
                }
              </td>
            }
          </ng-container>
        }
        @if (item==='arrow') {
          <ng-container *matCellDef="let element">
            @if (element['Enabled'] === true) {
              <td mat-cell
                (click)="pushPopElement(element)">
                @if (checkExpanded(element)) {
                  <span class="material-icons" matTooltip="Collapse">
                    expand_less
                  </span>
                } @else {
                  <span class="material-icons" matTooltip="More Details">
                    expand_more
                  </span>
                }
              </td>
            }
            @if (!element['Enabled']) {
              <td mat-cell>
              </td>
            }
          </ng-container>
        }
        @if (item === 'index') {
          <td mat-cell *matCellDef="let i = dataIndex">
            <p>{{i+1}}</p>
          </td>
        }
        @if (item!=='Enabled' && item !== 'arrow' && item !== 'index') {
          <ng-container *matCellDef="let element">
            <td mat-cell>
              <p [innerHTML]="getInput(element,item)"></p>
            </td>
          </ng-container>
        }
      </ng-container>
    }

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        @if (element.Parameters) {
          <div [@detailExpand]="checkExpanded(element) ? 'expanded' : 'collapsed'"
            [class.expandedDetail]="checkExpanded(element)">
            <table mat-table [dataSource]="element.Parameters" class="mat-subtable-custom" id="functionparameters">
              @for (item of subcolumnsToDisplay; track item) {
                <ng-container matColumnDef="{{item}}">
                  <th mat-header-cell *matHeaderCellDef> {{item === 'actions' ? '' : item === 'FunctionConfigControllerParameterId' ? 'Function Param Id' : item}}
                    @if (item !== 'Enabled' && item !== 'actions') {
                      <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="{{tooltips[item]}}">info</mat-icon>
                    }</th>
                    @if (item==='actions') {
                      <td mat-cell *matCellDef="let subelement">
                        @if (defaults.isControllerOwner) {
                          <button mat-icon-button matTooltip="Edit Row"
                            (click)="onRowEditInit(subelement, element)">
                            <mat-icon>edit</mat-icon>
                          </button>
                        }
                      </td>
                    }
                    @if (item!=='actions') {
                      <td mat-cell *matCellDef="let subelement">
                        <p [innerHTML]="getInput(subelement,item)"></p>
                      </td>
                    }
                  </ng-container>
                }
                <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
                <tr mat-row *matRowDef="let i2 = index; columns: subcolumnsToDisplay;"
                class="subitem"></tr>
              </table>
            </div>
          }
        </td>
      </ng-container>

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item">
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>

      </table>
    </div>

